import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { Modal } from "../../../../../theme/Component/Modal";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { EditorContractArticles } from "../../../../../contract/etapa-contrato/contrac/EditorContractArticles";
import { EditorBudgetItemArticles } from "../../../../../Talentohumano/GestionTH/SupplierPaymentOrderItem/EditorBudgetItemArticles";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { SupplierPaymentOrderItem } from "../../../../../Talentohumano/GestionTH/SupplierPaymentOrderItem/SupplierPaymentOrderItem";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP002 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({})
    const [obs, setObs] = useState<string>("")
    const [nItems, setNItems] = useState<number>(NaN)

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(obs)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ Response: `se agrego un listado de objetos de ${nItems} item(s)` })
        }

        toast.success(`Se ha agregado correctamente los items`)
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <SupplierPaymentOrderItem SupplierPaymentOrder={props} addType="fromRP" listLength={setNItems} />
            </div>
            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea name="Description" className="form-control" rows={5} value={obs} onChange={(e) => { setObs(e.target.value) }} />
            </div>

            <div className="col-md-12 mt-4">
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton eventClick={() => {
                            if (nItems > 0) {
                                onExportMap();
                            } else {
                                toast.error("Se necesita al menos un item para pagar")
                            }
                        }} icon="ri-save-line" children={"Guardar Items"} />
                    </div>
                </div>
            </div>
            <div className="col-md-12"></div>
        </div >
    )
}